namespace Matrix.Visualizer {
    export interface GraphRow {
        GraphKey?: string;
        Description?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace GraphRow {
        export const idProperty = 'GraphKey';
        export const nameProperty = 'Description';
        export const localTextPrefix = 'Visualizer.Graph';
        export const lookupKey = 'Visualizer.Graph';

        export function getLookup(): Q.Lookup<GraphRow> {
            return Q.getLookup<GraphRow>('Visualizer.Graph');
        }
        export const deletePermission = 'DataAdmin:Visualizer';
        export const insertPermission = 'DataAdmin:Visualizer';
        export const readPermission = 'Read:Visualizer';
        export const updatePermission = 'DataAdmin:Visualizer';

        export declare const enum Fields {
            GraphKey = "GraphKey",
            Description = "Description",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
